import { render } from "./FileRequests.vue?vue&type=template&id=34f2bae6&scoped=true"
import script from "./FileRequests.vue?vue&type=script&lang=js"
export * from "./FileRequests.vue?vue&type=script&lang=js"

import "./FileRequests.vue?vue&type=style&index=0&id=34f2bae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f2bae6"]])

export default __exports__